<script lang="ts" setup>
import IconSvgBase from '~theme/components/atoms/icons/IconSvgBase.vue';
</script>

<template>
  <icon-svg-base :class="$style.path" :view-width="40" :view-height="40">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.666 21.6652C25.746 21.6652 24.9994 20.9185 24.9994 19.9985C24.9994 19.0785 25.746 18.3319 26.666 18.3319C27.586 18.3319 28.3327 19.0785 28.3327 19.9985C28.3327 20.9185 27.586 21.6652 26.666 21.6652ZM19.9994 21.6652C19.0794 21.6652 18.3327 20.9185 18.3327 19.9985C18.3327 19.0785 19.0794 18.3319 19.9994 18.3319C20.9194 18.3319 21.666 19.0785 21.666 19.9985C21.666 20.9185 20.9194 21.6652 19.9994 21.6652ZM13.3327 21.6652C12.4127 21.6652 11.666 20.9185 11.666 19.9985C11.666 19.0785 12.4127 18.3319 13.3327 18.3319C14.2527 18.3319 14.9994 19.0785 14.9994 19.9985C14.9994 20.9185 14.2527 21.6652 13.3327 21.6652ZM31.7844 8.21354C27.9777 4.40687 22.7094 2.70854 17.3277 3.5402C10.5327 4.6002 4.89936 10.0735 3.62769 16.8519C3.01602 20.1152 3.36769 23.4385 4.64602 26.4602C4.80936 26.8435 4.85936 27.2035 4.79436 27.5252L3.36602 34.6719C3.25602 35.2185 3.42769 35.7835 3.82102 36.1769C4.13602 36.4919 4.56102 36.6652 4.99936 36.6652C5.10769 36.6652 5.21769 36.6552 5.32602 36.6319L12.4644 35.2052C12.8744 35.1269 13.2727 35.2419 13.5377 35.3519C16.561 36.6302 19.8844 36.9802 23.146 36.3702C29.9244 35.0985 35.3977 29.4652 36.4577 22.6702C37.296 17.2902 35.5927 12.0219 31.7844 8.21354Z"
    />
  </icon-svg-base>
</template>

<style lang="scss" module>
.path {
  width: 1em;
  height: 1em;
  fill: currentColor;
}
</style>
